export enum GoogleRefererTypes {
  CLEAR_RWG_TOKEN = 'CLEAR_RWG_TOKEN',
  SET_RWG_TOKEN = 'SET_RWG_TOKEN',
}
